export default __webpack_public_path__ + "static/card-2-a02b6471af98d4040647a1a02d14eac7.svg";